import { Component, Input, input } from "@angular/core";
import IWorkflowHistoryItem from "@models/IWorkflowHistoryItem";

@Component({
  selector: "workflowHistory",
  templateUrl: "./workflowHistory.component.html",
  styleUrls: ["./workflowHistory.component.scss"],
  standalone: false
})
export class WorkflowHistoryComponent {
  @Input() data: IWorkflowHistoryItem[] = [];
  readonly showDays = input(false);
}
